import { useState, useEffect } from 'react';
import { getUserlist } from '../Redux/qms/action';
import moment from "moment";

export const useLogModal = (fetchLogsAction, initialLimit = 25) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [pageno, setPageNo] = useState(1);
    const [limit, setLimit] = useState(initialLimit);
    const [colorRow, setColorRow] = useState({});
    const [userSelectlist, setUserSelectlist] = useState([]);
    const [filterData, setFilterData] = useState({ user: "", date: null });
    const [searchedData, setSearchedData] = useState({ user: "", date: null });

    // Fetch logs data
    const fetchData = async (user, updated_date_range, id, page = 1, perPage = limit) => {
        if (!id || !isOpen) return;

        setLoading(true);
        try {
            fetchLogsAction({ 
                user, 
                updated_date_range, 
                pk: id, 
                page, 
                perPage 
            })((res) => {
                if (res?.status && res?.data) {
                    setLogData(res.data.results || []);
                    setTotalRows(res.data.count || 0);
                } else {
                    setLogData([]);
                    setTotalRows(0);
                }
                setLoading(false);
            });
        } catch (error) {
            console.error('Error fetching logs:', error);
            setLogData([]);
            setTotalRows(0);
            setLoading(false);
        }
    };

    // Fetch logs when dependencies change
    useEffect(() => {
        if (!selectedId || !isOpen) return;
        
        fetchData(
            searchedData?.user || "", 
            searchedData?.date || null, 
            selectedId, 
            pageno, 
            limit
        );
    }, [selectedId, isOpen, pageno, limit, searchedData]);

    // Fetch user list on mount
    useEffect(() => {
        getUserlist(1)((response) => {
            if (response?.data?.results) {
                setUserSelectlist(response.data.results);
            }
        });
    }, []);

    // Open modal with specific ID
    const openModal = (id) => {
        if (!id) return;
        
        setSelectedId(id);
        setIsOpen(true);
        setPageNo(1);
        setLogData([]);
        setColorRow({});
    };

    // Close modal and reset state
    const closeModal = () => {
        setIsOpen(false);
        setSelectedId(null);
        setLogData([]);
        setColorRow({});
        setLimit(initialLimit);
        setPageNo(1);
        setFilterData({ user: "", date: null });
        setSearchedData({ user: "", date: null });
    };

    // Handle pagination
    const handlePageChange = (page) => {
        setPageNo(page);
    };

    // Handle rows per page change
    const handlePerRowsChange = (newPerPage) => {
        setLimit(newPerPage);
        setPageNo(1);
    };

    // Handle row click
    const handleRowClick = (row) => {
        setColorRow(row);
    };

    // Handle filter changes
    const handleChangeFilter = (value, type = 'user') => {
        if (type === 'submit') {
            setSearchedData({ ...filterData });
            setPageNo(1); // Reset to first page on new search
        } else if (type === 'user') {
            setFilterData({ ...filterData, user: value?.value || "" });
        } else if (type === 'date') {
            let dateRange = null;
            
            if (value && value.length === 2 && value[0] && value[1]) {
                const start_date = moment(value[0]).format('MM/DD/YYYY HH:mm:ss');
                const end_date = moment(value[1]).format('MM/DD/YYYY HH:mm:ss');
                dateRange = `${start_date} - ${end_date}`;
            }
            
            setFilterData({ ...filterData, date: dateRange });
        } else if (type === 'reset') {
            setFilterData({ user: "", date: null });
            setSearchedData({ user: "", date: null });
            setPageNo(1);
        }
    };

    return {
        isOpen,
        selectedId,
        logData,
        loading,
        totalRows,
        pageno,
        limit,
        colorRow,
        userSelectlist,
        filterData,
        searchedData,
        openModal,
        closeModal,
        handlePageChange,
        handlePerRowsChange,
        handleRowClick,
        handleChangeFilter,
    };
};